import * as Api from './service'
export default {
  namespace: 'formula',
  state: {
    dataSource: {}
  },
  effects: {
    * queryHistoryPointDetail ({ payload }, { call, put }) {
      const {
        data: { data }
      } = yield call(Api.queryHistoryPointDetail, payload)
      yield put({
        type: 'save',
        payload: {
          dataSource: data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
